
import filters from "@/filters";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import JobSearchingComponent from "@/components/landing/JobSearching.vue";
import ModalReport from "@/components/report/ModalReport.vue";
import ModalCompleteReport from "@/components/report/ModalCompleteReport.vue";
import PaginationMiniComponent from "@/components/paginations/PaginationMini.vue";
import $ from "jquery";
import { ENUM_STATUS_APPLIED, SCHOOL_PARTNERSHIP } from "@/constants/enum.constant";
import { Watch } from "vue-property-decorator";
@Component({
  components: {
    JobSearchingComponent,
    ModalReport,
    ModalCompleteReport,
    PaginationMiniComponent,
  },
  filters,
})
export default class JobDetail extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectJobVacancyById", { namespace: "job" })
  private actionSelectJobVacancyById: any;
  @Action("actionReportJobById", { namespace: "job" })
  private actionReportJobById: any;
  @Action("actionSelectJobApplicant", { namespace: "job" })
  private actionSelectJobApplicant: any;
  @Action("actionPaginationJobApplicant", { namespace: "job" })
  private actionPaginationJobApplicant: any;
  @Action("actionDownloadCV", { namespace: "candidate" })
  private actionDownloadCV: any;

  // STATE
  @State("locale")
  private locale: any;
  @State("vacancy", { namespace: "job" })
  private vacancy: any;
  @State("array_cv", { namespace: "job" })
  private array_cv: any;
  @State("pagination_cv", { namespace: "job" })
  private pagination_cv: any;

  /* INITIALIZATION */
  private isShowReport: boolean = false;
  private isShowCompleteReport: boolean = false;
  private job: any | null = null;
  private is_status = ENUM_STATUS_APPLIED;

  private breadcumbs:any[] = [
    {
      text: "company",
      href: "company"
    },
  ]

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.actionSelectJobVacancyById({id: this.$route.params.id, listener: this.listenerJobVacancy});
  }

  /* LIFECYCLE */
  private isPartnership(data: any) {
    if (data.partnership) return data.partnership.latest_history.status === SCHOOL_PARTNERSHIP.ACTIVE;
    return false;
  }

  private listenerReport() {
    this.isShowReport = false;
    this.isShowCompleteReport = true;
    this.actionSelectJobVacancyById({ id: this.$route.params.id });
  }

  private listenerJobVacancy() {
    this.actionSelectJobApplicant()
    this.breadcumbs.push({
      text: this.vacancy.detail.company.company_name,
      href: 'companyDetail',
      params: this.vacancy.detail.company.id,
      isName: true,
    });
  }

  /* METHODS */

  private reportedAction(suspension_reason: string) {
    const params = {
      spam: suspension_reason === "This is spam.",
      inapropriate: suspension_reason === "This is inappropriate.",
    };
    this.actionReportJobById({ params, listener: this.listenerReport });
  }

  private clickSearch(search: string = "") {
    this.actionSelectJobApplicant({ search });
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationJobApplicant({ url, page });
    } else {
      this.clickSearch();
    }
  }

  private limitText(text: string, limit = 200, warper = "...") {
    if (limit > 0) {
      let newText = String($("<div>").html(text).text());
      if (newText.length > limit) {
        return (newText = newText.substring(0, limit) + warper);
      }
      return newText;
    }
    return text;
  }

  private clickCandidate(user: any) {
    this.$router.push({ name: "candidateDetail", params: { id: user.id } });
  }
}
